
	import { defineComponent } from 'vue';

	export default defineComponent({
		name: 'Figure',
		props: {
			errors: {
				type: Number,
				default: 0,
				required: true,
				validator: (v: number) => v >= 0 && v <= 6,
			},
		},
		emits: ['gameover'],
		watch: {
			errors(v: number) {
				if (v === 6) this.$emit('gameover');
			},
		},
	});
